import React from 'react';
import ContentHeader from '../../../shared/ContentHeader';
import DetailHeader from '../../../shared/DetailHeader';
import ObjectEntry from '../../../Object/Entry'
import NoRecordsFound from '../../../shared/NoRecordsFound'
import {getCurrentLanguage} from '../../../../localData';
import settings from '../../../../../config/settings';
import Icon from '../../../shared/Icon';


const ObjectListByCategoryId = (props) => {
    let objects = props.store.objectsByCategoryId.edges.map(edge => {
        return <ObjectEntry key={ edge.node.id } object={ edge.node } />
    });

    let icon;
    const navItem = settings.navigation.find((item) => props.location.pathname.indexOf(item.url) > -1);
    if (!!navItem && !!navItem.icon) {
        icon = <Icon icon={navItem.icon} />;
    }

    return (
        <div styleName="container">
            <DetailHeader
                relay={ props.relay }
                detail={{
                    icon: !!icon ? icon : null,
                    title: props.store.content.ConTxt,
                }}
                simple
            />
            <div id="detailHeader">
                <ContentHeader title={ props.store.content.ConTxt }
                               icon={ icon }
                />
            </div>
            <div className="page-content">
                <ul className="object-list">
                    { objects.length ? objects : <NoRecordsFound lang={ getCurrentLanguage() } /> }
                </ul>
            </div>
        </div>
    )
};

export default ObjectListByCategoryId;


// WEBPACK FOOTER //
// ./app/components/Object/List/ByCategoryId/ObjectListByCategoryId.jsx